import React from "react";
//

import { SEOHelmet } from "../components/common/SEOHelmet";
import { TeamPreviewSection } from "../components/common/TeamPreviewSection";
import { TreatmentInfoBanner } from "../components/common/TreatmentInfoBanner";
import { LogoSvg } from "../components/svgs/LogoSvg";
import { InstagramSection } from "../components/common/InstagramSection";
//
import { PrimaryButton } from "../components/common/PrimaryButton";
import { PATH_GROUP_THERAPY, PATH_START } from "../utils/constants";
import groupsData from "../data/groups.json";
import { Group } from "../types/group";
import { Link } from "react-router-dom";

// removed unused 'data' definition

export default function StartPage() {


  return (
    <>
      <SEOHelmet page="start" pathname={PATH_START} />
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "MedicalBusiness",
          "name": "Ergotherapie Rottweil - Lisa Spreitzer",
          "alternateName": "ERGOTHERAPIE UND ZEIT(T)RÄUME",
          "description": "Professionelle Ergotherapie-Praxis in Rottweil. Ganzheitliche Therapie für Neurologie, Psychiatrie, Geriatrie und Pädiatrie. Individuelle Betreuung und Hausbesuche.",
          "url": "https://ergorw.de",
          "telephone": "+49-741-89698293",
          "email": "info@ergorw.de",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Auf dem Wall 29",
            "addressLocality": "Rottweil",
            "addressRegion": "Baden-Württemberg",
            "postalCode": "78628",
            "addressCountry": "DE"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "48.1684",
            "longitude": "8.6278"
          },
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
              "opens": "08:00",
              "closes": "18:00"
            }
          ],
          "priceRange": "$$",
          "image": "https://ergorw.de/images/tree.jpeg",
          "founder": {
            "@type": "Person",
            "name": "Lisa Spreitzer",
            "jobTitle": "Ergotherapeutin"
          },
          "medicalSpecialty": ["Neurologic", "Psychiatric", "Geriatric", "Pediatric"],
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Ergotherapie Leistungen",
            "itemListElement": [
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "MedicalTherapy",
                  "name": "Neurologische Ergotherapie",
                  "description": "Behandlung bei Schlaganfall, MS, Parkinson und anderen neurologischen Erkrankungen"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "MedicalTherapy",
                  "name": "Psychiatrische Ergotherapie",
                  "description": "Therapie bei Depression, Burnout und Angststörungen"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "MedicalTherapy",
                  "name": "Geriatrische Ergotherapie",
                  "description": "Therapie für Senioren bei Demenz und Alterserkrankungen"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "MedicalTherapy",
                  "name": "Pädiatrische Ergotherapie",
                  "description": "Kindertherapie bei ADHS und Entwicklungsstörungen"
                }
              }
            ]
          },
          "areaServed": {
            "@type": "City",
            "name": "Rottweil"
          },
          "sameAs": [
            "https://www.instagram.com/ergotherapie_zeittraeume/"
          ]
        })}
      </script>

      <main className="space-y-16 sm:space-y-24">
        {/* Hero Section */}
        <section>
          <div className="lg:grid lg:grid-cols-12 lg:gap-x-10 xl:gap-x-14 items-center">
            <div className="lg:col-span-7 xl:col-span-6">
              <header className="mb-6">
                <LogoSvg
                  classNames="h-12 w-auto fill-current text-ergo-500 dark:text-ergo-400"
                  aria-label="Ergotherapie Rottweil Logo"
                />
              </header>
              <h1
                className="text-3xl sm:text-5xl lg:text-5xl font-semibold tracking-tight leading-[1.15] text-gray-900 dark:text-white"
              >
                Einzigartige Menschen, <br className="hidden sm:block" />
                <span className="text-ergo-600 dark:text-ergo-400">individuelle Therapien.</span>
              </h1>
              <div className="mt-8 sm:mt-10 space-y-4">
                <p className="text-base leading-relaxed text-gray-500 dark:text-gray-400">
                  Herzlich willkommen in unserer Praxis für{" "}
                  <span className="font-medium text-gray-700 dark:text-gray-200">ERGOTHERAPIE UND ZEIT(T)RÄUME</span>
                </p>
                <p className="text-base leading-relaxed text-gray-500 dark:text-gray-400">
                  Wir unterstützen, beraten, coachen und motivieren unsere Klienten:Innen in vielfältiger Weise.
                </p>
              </div>
            </div>
            <aside className="mt-10 lg:mt-0 lg:col-span-5 xl:col-span-6">
              <img
                src={process.env.PUBLIC_URL + "/images/tree.jpeg"}
                alt="Ergotherapie Rottweil - Moderne Praxisräume in ruhiger Umgebung mit Außenbereich"
                className="w-full rounded-2xl object-cover shadow-md aspect-[4/3] max-h-[500px]"
              />
            </aside>
          </div>
        </section>

        {/* Mission Statement Section */}
        <section aria-label="Unsere Mission">
          <div className="lg:grid lg:grid-cols-2 gap-x-12 gap-y-6">
            <p className="text-base leading-relaxed text-gray-500 dark:text-gray-400">
              Es ist uns sehr wichtig, dass die Therapie an Ihrem Alltag ansetzt, sodass gemeinsam erarbeitete
              Strategien zu Hause umgesetzt werden können. Wir setzen an Ihren aktuellen Bedürfnissen und Wünschen an
              und beziehen ihre bereits vorhandenen Ressourcen mit in die Therapie ein.
            </p>
            <p className="text-base leading-relaxed text-gray-500 dark:text-gray-400">
              Die ganzheitliche Betrachtungsweise unserer Klienten:Innen ist uns sehr wichtig. Deshalb werden nach
              Möglichkeit auch Angehörige bzw. enge Bezugspersonen mit in die Therapie integriert. Unsere
              Behandlungsschwerpunkte liegen in den Bereichen{" "}
              <span className="font-medium text-gray-700 dark:text-gray-200">Neurologie</span> und{" "}
              <span className="font-medium text-gray-700 dark:text-gray-200">Psychiatrie</span>.
            </p>
          </div>

          <div className="mt-12">
            <TreatmentInfoBanner />
          </div>
        </section>

        {/* Gruppentherapien CTA */}
        <section aria-label="Gruppentherapien Hinweis">
          <div className="relative overflow-hidden rounded-2xl border border-gray-200/60 dark:border-gray-700/40 bg-white dark:bg-gray-800/60 shadow-sm p-6 sm:p-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
            <div>
              <h2 className="text-xl sm:text-2xl font-semibold tracking-tight text-gray-900 dark:text-white">Gruppentherapien</h2>
              <p className="mt-2 text-sm sm:text-base text-gray-500 dark:text-gray-400 max-w-2xl">
                Neu: Unsere Gruppentherapien – kompakt vorgestellt mit Inhalten und PDF.
              </p>
              {/* Preview of first 3 group covers */}
              <Link to={PATH_GROUP_THERAPY} className="group inline-block mt-5" aria-label="Gruppentherapien Vorschau öffnen">
                <div className="flex items-center -space-x-4">
                  {((groupsData as { groups: Group[] }).groups).map((g, i) => (
                    <img
                      key={g.id}
                      src={g.coverImage || `/images/gruppen/${g.id}-cover.jpg`}
                      onError={(e) => {
                        const el = e.currentTarget as HTMLImageElement;
                        el.src = `/images/gruppen/${g.id}-cover-1.jpg`;
                      }}
                      alt={g.description ? `Gruppentherapie: ${g.description.substring(0, 100)}...` : `Gruppentherapie ${g.title} in Rottweil`}
                      className={`h-24 w-18 sm:h-28 sm:w-20 object-cover rounded-xl ring-2 ring-white dark:ring-gray-900 shadow-sm transition-transform duration-300 ${i % 3 === 0 ? "rotate-[-2deg]" : i % 3 === 1 ? "rotate-0" : "rotate-[2deg]"} group-hover:-translate-y-0.5`}
                    />
                  ))}
                </div>
              </Link>
            </div>
            <div className="flex-shrink-0">
              <PrimaryButton to={PATH_GROUP_THERAPY}>Zur Übersicht</PrimaryButton>
            </div>
          </div>
        </section>

        {/* Team Preview Section */}
        <TeamPreviewSection />

        {/* Instagram Section */}
        <InstagramSection />
      </main>
    </>
  );
}
